import i18next from 'i18next';

import en from './en';
import ua from './ua';

export const IMPERSONATION_TRANSLATION_KEY = 'impersonation';

i18next.addResourceBundle('en-US', IMPERSONATION_TRANSLATION_KEY, en);
i18next.addResourceBundle('uk-UA', IMPERSONATION_TRANSLATION_KEY, ua);
